import { Feedback } from './feedback.model';

// Without this dynamic parameter AOT compiling will fail.
// @see https://angular.io/guide/angular-compiler-options#strictmetadataemit
// @dynamic
export class InformationalFeedback extends Feedback {
  public static fromDto(dto: any): InformationalFeedback {
    const feedback: InformationalFeedback = new InformationalFeedback();
    Feedback.mapBaseProperties(feedback, dto);
    return feedback;
  }
}
